<app-modal-loading-screen *ngIf="isDeletingPrf">Deleting PRF</app-modal-loading-screen>

<div class="upload-progress-shell">
	<h5 class="upload-title">Uploading PRF Template</h5>
	<p class="upload-message" *ngIf="fileName">
		{{ fileName }} is being processed step by step.
	</p>
	<p class="upload-message" *ngIf="!fileName">
		Your Excel file is being processed step by step.
	</p>

	<div class="progress-summary">
		<div class="progress-bar-track">
			<div class="progress-bar-fill" [style.width.%]="progressPercentage"></div>
		</div>
		<div class="progress-percentage">{{ progressPercentage }}%</div>
	</div>

	<p class="steps-completed-text">
		{{ completedStepsCount }} of {{ steps.length }} steps completed
	</p>

	<div class="progress-container">
		<div class="progress-steps">
			<div class="step" *ngFor="let step of steps; let i = index" [class.completed]="step.completed"
				[class.current]="isCurrentStep(i)" [class.skipped]="step.status === 'skipped'">
				<div class="step-indicator" [class.completed]="step.completed" [class.current]="isCurrentStep(i)"
					[class.error]="step.status === 'error'" [class.skipped]="step.status === 'skipped'">
					<mat-icon *ngIf="step.completed && step.status === 'error'">close</mat-icon>
					<mat-icon *ngIf="step.completed && step.status === 'skipped'">remove</mat-icon>
					<mat-icon *ngIf="step.completed && step.status !== 'error' && step.status !== 'skipped'">check</mat-icon>
					<span *ngIf="!step.completed">{{ i + 1 }}</span>
				</div>
				<div class="step-content">
					<div class="step-label">{{ step.label }}</div>
					<p class="step-error-message" *ngFor="let msg of step.message" [hidden]="step.status !== 'error'">{{
						msg }}</p>
				</div>
				<div class="step-status" [class.completed]="step.completed" [class.current]="isCurrentStep(i)"
					[class.error]="step.status === 'error'" [class.skipped]="step.status === 'skipped'">
					{{ getStepStatus(i) }}
				</div>
			</div>
		</div>
	</div>

	<div class="upload-success" *ngIf="isComplete">
		<div class="upload-success__summary" *ngIf="isSuccess">
			<div class="upload-success__icon">
				<mat-icon>check</mat-icon>
			</div>
			<div class="upload-success__content">
				<p class="upload-success__title">PRF template uploaded successfully</p>
				<p class="upload-success__subtitle">All {{ steps.length }} steps completed.</p>
			</div>
		</div>
		<div class="upload-success__summary" *ngIf="!isSuccess">
			<div class="upload-fail__icon">
				<mat-icon>close</mat-icon>
			</div>
			<div class="upload-success__content">
				<p class="upload-fail__title">PRF template upload Failed</p>
				<p class="upload-fail__subtitle">Some steps couldn't be completed.</p>
			</div>
		</div>

		<div class="upload-success__action">
			<app-button size="medium" buttonType="primary" *ngIf="isSuccess" (click)="viewPrf()" (keydown.enter)="viewPrf()">
				View PRF
			</app-button>
		</div>
		<div class="upload-fail-actions" *ngIf="(!isSuccess) && operatorInput.prfCreated">
			<app-button size="medium" buttonType="secondary" (click)="viewPrf()" (keydown.enter)="viewPrf()">
				Complete PRF manually
			</app-button>
			<app-button size="medium" buttonType="error" (click)="deletePrf()" (keydown.enter)="deletePrf()">
				Delete PRF
			</app-button>
		</div>
	</div>
</div>